export enum ProductTileScreen {
  PRODUCT_TILE_SCREEN_UNKNOWN = 'PRODUCT_TILE_SCREEN_UNKNOWN',
  PRODUCT = 'PRODUCT',
  BRAND_PAGE = 'BRAND_PAGE',
  BRAND_PRODUCT_SEARCH_RESULTS = 'BRAND_PRODUCT_SEARCH_RESULTS',
  CATEGORY_PRODUCT_RESULTS = 'CATEGORY_PRODUCT_RESULTS',
  BOARDS = 'BOARDS',
  BUY_AGAIN = 'BUY_AGAIN',
  CHECKOUT_BRAND = 'CHECKOUT_BRAND',
  PRODUCT_BASED_COLLECTION = 'PRODUCT_BASED_COLLECTION',
  BRAND_VIDEO_LIBRARY = 'BRAND_VIDEO_LIBRARY',
  MY_BRANDS = 'MY_BRANDS',
  HOME = 'HOME',
  SEARCH_PRODUCT_RESULTS = 'SEARCH_PRODUCT_RESULTS',
  ORDER_DETAILS = 'ORDER_DETAILS',
  NEW_ARRIVALS = 'NEW_ARRIVALS',
  CART = 'CART',
  SIMILAR_PRODUCTS = 'SIMILAR_PRODUCTS',
  POST_ORDER = 'POST_ORDER',
  DIGEST_PAGE_SCREEN = 'DIGEST_PAGE_SCREEN',
  /**
   * @deprecated
   */
  BRAND_INSIGHTS_PAGE = 'BRAND_INSIGHTS_PAGE',
  REORDER_BRANDS_PAGE = 'REORDER_BRANDS_PAGE',
  FOLLOWED_BRANDS_PAGE = 'FOLLOWED_BRANDS_PAGE',
  BRAND_VIDEO_PLAYER = 'BRAND_VIDEO_PLAYER',
  LOGGED_OUT_HOME = 'LOGGED_OUT_HOME',
  DISCOVER_PAGE_SCREEN = 'DISCOVER_PAGE_SCREEN',
  BUNDLES_PAGE = 'BUNDLES_PAGE',
  EXCLUSIVITY = 'EXCLUSIVITY',
}
